<template>
  <v-app>
    <meta name="All github commit numberg" :latest-commit-number="latestCommitNumber">
    <meta name="All github tag" :latest-tag="latestTag ">
    <!-- <div v-if="!(isLocalhost8080 || isCloudFront)" > -->
    <!-- <div v-if="!(production || isCloudFront)" >
    <div class="github">
      <p>sample</p>
      <p><span class="github-tag-font-color">Commit number</span>: ({{ latestCommitNumber }})</p>
      <p><span class="github-tag-font-color">get latest tag</span>: ({{ latestTag }})</p>
    </div>
    </div> -->
    <header-toolbar></header-toolbar>
    <transition name="fade">
      <router-view/>
    </transition>
    <footer-toolbar></footer-toolbar>
  </v-app>
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.github{
  margin-left: 70%;

  font-size: 15px;
}
.github-tag-font-color{
  font-weight: bold;
}
</style>

<script>
import HeaderToolbar from '@/components/HeaderToolbar.vue'
import FooterToolbar from '@/components/FooterToolbar.vue'
export default {
  name: 'App',
  components: {
    HeaderToolbar,
    FooterToolbar
  },
  data () {
    return {
      latestCommitNumber: '',
      allCommitNumber: '',
      latestTag: '',
      allTag: '',
      isLocalhost8080: '',
      isCloudFront: '',
      production: ''
    }
  },
  created () {
    const selectItems = require('@/file.json')
    console.log(selectItems)
    this.latestCommitNumber = selectItems.commitNumber[0]
    this.latestTag = selectItems.latestTag
    this.allCommitNumber = selectItems.commitNumber
    this.allTag = selectItems.tags
  },
  mounted () {
    const { hostname, port } = window.location
    // ホスト名がlocalhostでポート番号が8080の場合にフラグをtrueに設定
    this.isLocalhost8080 = hostname === 'localhost' && port === '8081'
    this.isCloudFront = hostname === 'd34udgl6q4ivs5.cloudfront.net'
    this.production = hostname === 'investors-survey.japan-reit.com'
  }
}
</script>
